$(document).ready(function(){
  if (document.body.clientWidth < 1000) {
    $(".product-info__block-item[data-block-type=title]").insertBefore(".product-gallery");
    $(".product-info__block-item[data-block-type=price]").insertAfter(".product-info__block-item[data-block-type=variant-picker]");
    } else { 
    $(".product-info__block-item[data-block-type=title]").insertBefore(".product-info__block-item[data-block-type=price]");
    $(".product-info__block-item[data-block-type=price]").insertBefore(".product-info__block-item[data-block-type=liquid]");
  }


$(".accordion-group .accordion:eq(0)").addClass('active');
$(".accordion.group.active .accordion__content").show();   
  
   $(".accordion .accordion__toggle").click(function(){
   $(".accordion.group").removeClass('active');
   $(this).parent().closest('.accordion').toggleClass('active');
   $(".accordion.group .accordion__content").hide();
   $(".accordion.group.active .accordion__content").show(); 
   });

  
});
 

